import { generateURL } from './prefix';
import api from '../api';

export const getAdministratorWebhookProcessor = async () => {
    const url = generateURL(`/webhook/processar`);

    const { data } = await api.get(url);

    return data;
};